/**
 * PostHog Client-Side Tracking
 * Mirrors Mixpanel events to PostHog for funnel analysis
 *
 * Note: PostHog is initialized in lib/instrumentation-client.js
 */

import posthog from 'posthog-js'

/**
 * Initialize PostHog client (now handled by instrumentation-client.js)
 * @deprecated Use instrumentation-client.js for initialization
 */
export function initPostHog() {
  // PostHog is now initialized via instrumentation-client.js
  // This function is kept for backwards compatibility
  console.log('PostHog initialization is handled by instrumentation-client.js')
}

/**
 * Identify user in PostHog
 * @param userId - Unique user ID
 * @param properties - User properties (email, name, plan, etc.)
 */
export function identifyUser(userId: string, properties?: Record<string, any>) {
  if (typeof window === 'undefined') return

  posthog.identify(userId, properties)
}

/**
 * Track an event in PostHog
 * @param eventName - Event name (should match Mixpanel event names)
 * @param properties - Event properties
 */
export function sendEventToPosthog(
  eventName: string,
  properties?: Record<string, any>,
) {
  if (typeof window === 'undefined') return

  posthog.capture(eventName, properties)
}

/**
 * Reset PostHog (e.g., on logout)
 */
export function resetPostHog() {
  if (typeof window === 'undefined') return

  posthog.reset()
}

/**
 * Get the current PostHog distinct ID
 */
export function getDistinctId(): string | undefined {
  if (typeof window === 'undefined') return undefined

  return posthog.get_distinct_id()
}

// Export the PostHog instance for advanced usage
export { posthog }
